import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import axios from 'axios';
import Carousel from 'react-bootstrap/Carousel';



const IsuEkonomiDetail = () => {
    const { t } = useTranslation();
    dayjs.locale('id');

    const { id, slug } = useParams();
    const [rows, setItem] = useState(null);

    const [itemx, setItemx] = useState([]);

    const resolveImageUrl = (path, type = 'news') => {
        if (!path || path === "") return '/assets/image/foto-beritas.png';
        if (path.startsWith('http://') || path.startsWith('https://')) {
            return path;
        }
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        if (cleanPath.startsWith('/assets/') || cleanPath.startsWith('/static/')) {
            const publicUrl = process.env.PUBLIC_URL || '';
            const cleanPublicUrl = publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
            return `${cleanPublicUrl}${cleanPath}`;
        }
        if (path.includes('uploads/') || path.includes('storage/')) {
            const cmsUrl = process.env.REACT_APP_API_URL || 'https://cms.kneks.go.id';
            const cleanCmsUrl = cmsUrl.endsWith('/') ? cmsUrl.slice(0, -1) : cmsUrl;
            return `${cleanCmsUrl}${cleanPath}`;
        }
        if (type === 'gallery') {
            const galleryBase = process.env.REACT_APP_API_PHOTO_BERITA || 'https://cms.kneks.go.id/uploads/photo/';
            const cleanGalleryBase = galleryBase.endsWith('/') ? galleryBase : `${galleryBase}/`;
            return `${cleanGalleryBase}${path.startsWith('/') ? path.slice(1) : path}`;
        } else {
            const newsBase = process.env.REACT_APP_API_NEWS || 'https://cms.kneks.go.id/storage/news/';
            const cleanNewsBase = newsBase.endsWith('/') ? newsBase : `${newsBase}/`;
            return `${cleanNewsBase}${path.startsWith('/') ? path.slice(1) : path}`;
        }
    };


    const convertToSlug = (title) => {
        if (!title) return ""; // Handle null or undefined title
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
    };
    const effectrun = useRef(false);
    useEffect(() => {
        if (effectrun.current === false) {
            const fetchPosts = async () => {
                try {
                    const url = process.env.REACT_APP_API_URL;
                    const endpoint = process.env.REACT_APP_API_POST;
                    const responsei = await axios.get(`${url}/newsdetail/${id}`);
                    const responlain = await axios.get(`${url}${endpoint}`);

                    const foundItem = responsei.data.find(
                        (post) =>
                            post.id === Number(id) &&
                            convertToSlug(post.title) === slug
                    );

                    // throw new Error("Error!");

                    if (responlain) {
                        setItemx(responlain.data);
                        setItem(foundItem);
                    }
                } catch (err) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: err.message || "An error occurred while fetching data.",
                    });
                }
            };

            fetchPosts();

            return () => {
                effectrun.current = true
            }
        }
    }, [id, slug]);
    const formattedDate = rows?.news_datetime ? dayjs(rows.news_datetime).format("DD MMMM YYYY") : "Tanggal tidak tersedia";

    const images = [];
    if (rows) {
        const data = rows;
        // Collect image URLs from `image` field (may contain comma-separated URLs)
        if (data?.image && data?.image !== "") {
            const imgList = data.image.split(',').map(s => s.trim()).filter(Boolean);
            imgList.forEach(url => images.push(resolveImageUrl(url, 'news')));
        }
        // Collect images from `foto_gallery` array if present
        if (Array.isArray(data?.foto_gallery) && data.foto_gallery.length > 0) {
            data.foto_gallery.forEach(result => {
                if (result?.foto) {
                    images.push(resolveImageUrl(result.foto, 'gallery'));
                }
            });
        }
        // Fallback placeholder when no images were resolved
        if (images.length === 0) {
            images.push('/assets/image/foto-beritas.png');
        }
    }



    return (
        <>
            <div className="page-wrapper">
                <section className="page-banner">
                    <div className="container">
                        <div className="page-banner-title">
                            <h3>{t('isuEkonomi')}</h3>
                        </div>
                    </div>
                </section>
                <section className="event-details-section-ber">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="event-details-content-box">
                                    <h4>{rows?.title}</h4>
                                    <p>{formattedDate}</p>
                                </div>
                            </div>
                            <div className="col-lg-12 pb-4">
                                {images.length > 0 ? (
                                    <Carousel
                                        interval={3000}
                                        controls={images.length > 1}
                                        indicators={images.length > 1}
                                        className="news-carousel-container"
                                    >
                                        {images.map((imgSrc, idx) => (
                                            <Carousel.Item key={idx}>
                                                <div className="news-carousel-img-wrapper">
                                                    <img
                                                        src={imgSrc}
                                                        className="news-carousel-img img-fluid"
                                                        alt={`${rows?.title || 'Berita'} - ${idx + 1}`}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = `/assets/image/foto-beritas.png`;
                                                        }}
                                                    />
                                                </div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                ) : (
                                    <div className="event-details-inner-box">
                                        <img src='/assets/image/foto-beritas.png' width="100%" className="img-fluid" alt="" />
                                    </div>
                                )}
                            </div>

                            <div className="row">
                                {rows?.foto_gallery && rows?.foto_gallery.length > 0 ? (
                                    rows?.foto_gallery.map((result, index) => (
                                        <div className="col-lg-3 pb-3" key={index}>
                                            <a href={resolveImageUrl(result.foto, 'gallery')} className="beritaDetail" data-gall="gallery01">
                                                <img
                                                    src={resolveImageUrl(result.foto, 'gallery')}
                                                    width="100%"
                                                    style={{ height: "195px" }}
                                                    className="img-fluid"
                                                    alt={rows?.title}
                                                />
                                            </a>
                                        </div>
                                    ))
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div className="col-lg-12">
                                <div className="event-details-content-box">
                                    {/* <p style={{ textAlign: `justify` }}>{rows?.content}</p> */}
                                    <div dangerouslySetInnerHTML={{ __html: rows?.content }} />
                                </div>
                            </div>
                            <hr />
                            <div className="news-details-list-title pb-3">
                                <h4>Tags :</h4>
                            </div>
                            {/* {(rows?.tagging || "").trim().length > 0 && (
                                <div className="news-details-list-button">
                                    {(rows?.tagging || "")
                                        .split(",")
                                        .map((tag, index) => (
                                            <a href="#t" key={index} className="btn btn-primary">{tag.trim()}</a>
                                        ))}
                                </div>
                            )} */}
                            {rows?.tagging && (
                                <div className="news-details-list-button">
                                    {(JSON.parse(rows.tagging || '[]')).map((t, i) => (
                                        <a key={i} href="#t" className="btn btn-primary me-2">
                                            {t.value}
                                        </a>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </section>

                <section className="berita-section-det">
                    <div className="container">
                        <div className="row row-gutter-y-40 mb-5">
                            <div className="col-lg-12 col-xl-12">
                                <div className="about-one-inner">
                                    <div className="section-tagline">
                                        Berita Lainnya
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row row-gutter-30">
                            {itemx.slice(0, 3).map((item) => {
                                return (
                                    <div className="col-lg-4 col-xl-4" key={item.id}>
                                        <div className="berita-card">
                                            <div className="berita-card-imgbox ">
                                                {/* <a href={`/liputan-media/${convertToSlug(item.title)}`}> <img src={`${process.env.REACT_APP_API_NEWS}` + item.image} className="img-fluid" alt={item.title} /></a> */}
                                                <a href={`/isu-ekonomi/${item.id}/${convertToSlug(item.title)}`}>
                                                    <img
                                                        src={item?.image === "" ? '/assets/image/foto-beritas.png' : item?.image}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = `/assets/image/foto-beritas.png`;
                                                        }}
                                                        className="img-fluid w-100" alt={item.title} /></a>
                                            </div>
                                            <div className="berita-content ">
                                                <div className="event-card-info-x " style={{ color: `#F2994A` }}>
                                                    {/* <span>#BERITABARU</span> */}
                                                    {item.tags.split(",").map((tag, index) => (
                                                        <span key={index}>{tag ? '#' + tag : ''} </span>
                                                    ))}
                                                </div>
                                                <div className="event-card-title pb-4">
                                                    <h4>
                                                        <a href={`/isu-ekonomi/${item.id}/${convertToSlug(item.title)}`}>{item.title}</a>
                                                    </h4>
                                                </div>
                                                <div className="event-card-info">
                                                    <span>{dayjs(rows.news_datetime).format("DD MMMM YYYY")}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>

            </div>
        </>
    )
}

export default IsuEkonomiDetail
